import { useBusinessPreferences } from "hooks/usePreferences";
import { formatPhoneForDisplay } from "../../../../utils/phoneUtils";

/**
 * Custom phone number cell renderer that formats phone numbers according to business preferences
 * Uses context-based preferences for instant loading (no delay)
 */
const PhoneNumberCell = ({ value }) => {
    const { preferences } = useBusinessPreferences();

    if (!value) return null;

    // Use the utility function to format the phone number
    // Preferences are immediately available via context, no loading delay
    const { displayText } = formatPhoneForDisplay(value, preferences);

    return displayText;
};

export const validManufacturerColumns = [
    {
        Header: 'Manufacturer Name',
        accessor: 'name',
        enableFilter: true
    },
    {
        Header: 'Type',
        accessor: 'type',
        enableFilter: true,
        Cell: ({ value }) => {
            const typeMap = {
                'frame': 'Frame',
                'lens': 'Lens',
                'contact_lens': 'Contact Lens',
                'other': 'Other'
            };
            return typeMap[value] || value;
        }
    },
    {
        Header: 'Contact Person',
        accessor: 'contactPerson',
        enableFilter: true
    },
    {
        Header: 'Phone',
        accessor: 'phone',
        type: 'number',
        enableFilter: true,
        Cell: PhoneNumberCell
    },
    {
        Header: 'Email',
        accessor: 'email',
        enableFilter: true
    },
    {
        Header: 'Address',
        accessor: 'address'
    },
    {
        Header: 'Status',
        accessor: 'status',
        enableFilter: true
    }
]
